var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 2407,
    viewBox: "0 0 1920 2407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 1262,
    height: 1628,
    transform: "translate(0 4493)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 1572.287,
    height: 1480.695,
    transform: "translate(0 -0.005)",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 1176,
    height: 1641,
    transform: "translate(744 5377)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 49.602,
    height: 49.392,
    fill: "#ed3a72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(0 -4493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5005)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-2",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5058)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-3",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5111)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-4",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5164)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-5",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5217)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-6",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5270)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-7",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5323)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-8",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5376)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-9",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5429)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-10",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5482)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-11",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5535)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-12",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5588)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-13",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5641)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-14",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5694)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-15",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5747)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-16",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5800)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-17",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5853)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-18",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5906)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-19",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 5959)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-20",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 6012)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-21",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 6065)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-22",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 6118)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-23",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 6171)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-24",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 6224)",
    fill: "#eb506c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-25",
    "data-name": "Rectangle 112",
    width: 1920,
    height: 22,
    transform: "translate(0 6277)",
    fill: "#eb506c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(1393.458 4876.103) rotate(120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M71.879,371.543l-71.3,123.5,71.3,123.5h142.6l71.3-123.5-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M71.878,371.543h142.6l71.3,123.5-71.3,123.5H71.878L.577,495.04Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M72.643,124.1h142.6l71.3,123.5-71.3,123.5H72.643L1.342,247.6Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M72.643,124.1h142.6l71.3,123.5-71.3,123.5H72.643L1.342,247.6Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M287.023.495l-71.3,123.5,71.3,123.5h142.6l71.3-123.5L429.625.495Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M287.024.5h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M501.313,124.05h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M501.313,124.05h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M286.462,248.252h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M286.462,248.252h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M286.6,494.335h142.6l71.3,123.5-71.3,123.5H286.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M286.6,494.335h142.6l71.3,123.5-71.3,123.5H286.6l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M500.85,370.041h142.6l71.3,123.5-71.3,123.5H500.85l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M500.85,370.041h142.6l71.3,123.5-71.3,123.5H500.85l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M714.981,494.169h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M714.981,494.169h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M929.34,371.083h142.6l71.3,123.5-71.3,123.5H929.34l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M929.34,371.083h142.6l71.3,123.5-71.3,123.5H929.34l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1144.223,494.761h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1144.223,494.761h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M1357.808,371.471h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1357.808,371.471h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M715.493.661l-71.3,123.5,71.3,123.5h142.6l71.3-123.5L858.095.661Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M715.493.66H858.1l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M715.792,247.433h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M715.792,247.433h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M1143.088,247.992h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M1143.088,247.992h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1357.689,125.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M1357.689,125.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M929.487,124.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M929.487,124.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1143.349.931h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1143.349.931h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M287.35,740.609h142.6l71.3,123.5-71.3,123.5H287.35l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M287.35,740.609h142.6l71.3,123.5-71.3,123.5H287.35l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M286.887,986.6h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M286.887,986.6h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M501.018,1110.728h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M501.018,1110.728h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M715.378,987.642h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M715.378,987.642h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M930.261,1111.32h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M930.261,1111.32h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M715.838,1233.2l-71.3,123.5,71.3,123.5h142.6l71.3-123.5-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M715.837,1233.2h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M1143.845,988.029h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1143.845,988.029h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M501.53,617.219h142.6l71.3,123.5-71.3,123.5H501.53l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M501.53,617.219h142.6l71.3,123.5-71.3,123.5H501.53l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M501.83,863.991h142.6l71.3,123.5-71.3,123.5H501.83l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M501.83,863.991h142.6l71.3,123.5-71.3,123.5H501.83l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M929.125,864.551h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M929.125,864.551h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M1143.726,741.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M1143.726,741.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M715.524,740.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M715.524,740.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M929.386,617.49h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M929.386,617.49h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(0 -118)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(607.825 6634.655) rotate(-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135-2",
    "data-name": "Path 135",
    d: "M71.879,371.543l-71.3,123.5,71.3,123.5h142.6l71.3-123.5-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86-2",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85-2",
    "data-name": "Group 85",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136-2",
    "data-name": "Path 136",
    d: "M71.878,371.543h142.6l71.3,123.5-71.3,123.5H71.878L.577,495.04Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_137-2",
    "data-name": "Path 137",
    d: "M72.643,124.1h142.6l71.3,123.5-71.3,123.5H72.643L1.342,247.6Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88-2",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87-2",
    "data-name": "Group 87",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-2",
    "data-name": "Path 138",
    d: "M72.643,124.1h142.6l71.3,123.5-71.3,123.5H72.643L1.342,247.6Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_139-2",
    "data-name": "Path 139",
    d: "M287.023.495l-71.3,123.5,71.3,123.5h142.6l71.3-123.5L429.625.495Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90-2",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89-2",
    "data-name": "Group 89",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140-2",
    "data-name": "Path 140",
    d: "M287.024.5h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_141-2",
    "data-name": "Path 141",
    d: "M501.313,124.05h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-2",
    "data-name": "Path 142",
    d: "M501.313,124.05h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-2",
    "data-name": "Path 143",
    d: "M286.462,248.252h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144-2",
    "data-name": "Path 144",
    d: "M286.462,248.252h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145-2",
    "data-name": "Path 145",
    d: "M286.6,494.335h142.6l71.3,123.5-71.3,123.5H286.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146-2",
    "data-name": "Path 146",
    d: "M286.6,494.335h142.6l71.3,123.5-71.3,123.5H286.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147-2",
    "data-name": "Path 147",
    d: "M500.85,370.041h142.6l71.3,123.5-71.3,123.5H500.85l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148-2",
    "data-name": "Path 148",
    d: "M500.85,370.041h142.6l71.3,123.5-71.3,123.5H500.85l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149-2",
    "data-name": "Path 149",
    d: "M714.981,494.169h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150-2",
    "data-name": "Path 150",
    d: "M714.981,494.169h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151-2",
    "data-name": "Path 151",
    d: "M929.34,371.083h142.6l71.3,123.5-71.3,123.5H929.34l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152-2",
    "data-name": "Path 152",
    d: "M929.34,371.083h142.6l71.3,123.5-71.3,123.5H929.34l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153-2",
    "data-name": "Path 153",
    d: "M1144.223,494.761h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154-2",
    "data-name": "Path 154",
    d: "M1144.223,494.761h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155-2",
    "data-name": "Path 155",
    d: "M1357.808,371.471h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92-2",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91-2",
    "data-name": "Group 91",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156-2",
    "data-name": "Path 156",
    d: "M1357.808,371.471h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_157-2",
    "data-name": "Path 157",
    d: "M715.493.661l-71.3,123.5,71.3,123.5h142.6l71.3-123.5L858.095.661Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94-2",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93-2",
    "data-name": "Group 93",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158-2",
    "data-name": "Path 158",
    d: "M715.493.66H858.1l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_159-2",
    "data-name": "Path 159",
    d: "M715.792,247.433h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160-2",
    "data-name": "Path 160",
    d: "M715.792,247.433h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161-2",
    "data-name": "Path 161",
    d: "M1143.088,247.992h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162-2",
    "data-name": "Path 162",
    d: "M1143.088,247.992h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163-2",
    "data-name": "Path 163",
    d: "M1357.689,125.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96-2",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95-2",
    "data-name": "Group 95",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164-2",
    "data-name": "Path 164",
    d: "M1357.689,125.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_165-2",
    "data-name": "Path 165",
    d: "M929.487,124.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166-2",
    "data-name": "Path 166",
    d: "M929.487,124.068h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167-2",
    "data-name": "Path 167",
    d: "M1143.349.931h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98-2",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97-2",
    "data-name": "Group 97",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168-2",
    "data-name": "Path 168",
    d: "M1143.349.931h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_169-2",
    "data-name": "Path 169",
    d: "M287.35,740.609h142.6l71.3,123.5-71.3,123.5H287.35l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170-2",
    "data-name": "Path 170",
    d: "M287.35,740.609h142.6l71.3,123.5-71.3,123.5H287.35l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171-2",
    "data-name": "Path 171",
    d: "M286.887,986.6h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172-2",
    "data-name": "Path 172",
    d: "M286.887,986.6h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173-2",
    "data-name": "Path 173",
    d: "M501.018,1110.728h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174-2",
    "data-name": "Path 174",
    d: "M501.018,1110.728h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175-2",
    "data-name": "Path 175",
    d: "M715.378,987.642h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176-2",
    "data-name": "Path 176",
    d: "M715.378,987.642h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177-2",
    "data-name": "Path 177",
    d: "M930.261,1111.32h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178-2",
    "data-name": "Path 178",
    d: "M930.261,1111.32h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179-2",
    "data-name": "Path 179",
    d: "M715.838,1233.2l-71.3,123.5,71.3,123.5h142.6l71.3-123.5-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_100-2",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99-2",
    "data-name": "Group 99",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180-2",
    "data-name": "Path 180",
    d: "M715.837,1233.2h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_181-2",
    "data-name": "Path 181",
    d: "M1143.845,988.029h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182-2",
    "data-name": "Path 182",
    d: "M1143.845,988.029h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183-2",
    "data-name": "Path 183",
    d: "M501.53,617.219h142.6l71.3,123.5-71.3,123.5H501.53l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184-2",
    "data-name": "Path 184",
    d: "M501.53,617.219h142.6l71.3,123.5-71.3,123.5H501.53l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185-2",
    "data-name": "Path 185",
    d: "M501.83,863.991h142.6l71.3,123.5-71.3,123.5H501.83l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186-2",
    "data-name": "Path 186",
    d: "M501.83,863.991h142.6l71.3,123.5-71.3,123.5H501.83l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187-2",
    "data-name": "Path 187",
    d: "M929.125,864.551h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188-2",
    "data-name": "Path 188",
    d: "M929.125,864.551h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189-2",
    "data-name": "Path 189",
    d: "M1143.726,741.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190-2",
    "data-name": "Path 190",
    d: "M1143.726,741.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191-2",
    "data-name": "Path 191",
    d: "M715.524,740.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192-2",
    "data-name": "Path 192",
    d: "M715.524,740.627h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193-2",
    "data-name": "Path 193",
    d: "M929.386,617.49h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#fef587",
    stroke: "#ed3a72",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194-2",
    "data-name": "Path 194",
    d: "M929.386,617.49h142.6l71.3,123.5-71.3,123.5h-142.6l-71.3-123.5Z",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(296.094 4912.175) rotate(42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M31.348,23.223a8.523,8.523,0,0,1-6.537,2.84,8.333,8.333,0,0,1-6.471-2.792,2.646,2.646,0,0,0-.381.8,56.825,56.825,0,0,1-5.035,10.387,11.2,11.2,0,0,1-5.864,4.776,7.583,7.583,0,0,1-3.745.412A3.841,3.841,0,0,1,.033,35.211a10.88,10.88,0,0,1,2.245-5.1A52.055,52.055,0,0,1,11.7,20.647q1.859-1.535,3.836-2.918a1.076,1.076,0,0,0,.514-.857,7.61,7.61,0,0,1,3.311-5.632c.356-.255.427-.417.177-.821A4.045,4.045,0,0,1,20.8,4.547a.622.622,0,0,0,.308-.785A2.532,2.532,0,0,0,18.6,1.528a12.648,12.648,0,0,0-1.823-.1,1.022,1.022,0,0,1-.667-.2.621.621,0,0,1-.253-.671.69.69,0,0,1,.571-.514,3.136,3.136,0,0,1,1.407.089,13.806,13.806,0,0,1,2.99,1.1A1.823,1.823,0,0,1,21.81,2.4c.107.356.236.706.342,1.062.087.292.244.361.531.251A6.228,6.228,0,0,1,27.005,3.7c.3.1.454.041.492-.267A3.211,3.211,0,0,1,30.1.675,14.38,14.38,0,0,1,32.39.044,3.243,3.243,0,0,1,33.1.016c.412.035.722.22.719.688a.688.688,0,0,1-.7.719c-.572.052-1.149.052-1.722.084a4.767,4.767,0,0,0-.653.086,2.5,2.5,0,0,0-2.261,2.434.268.268,0,0,0,.115.3c.084.057.169.112.252.17a4.144,4.144,0,0,1,1.24,5.977c-.2.326-.2.472.122.7a7.5,7.5,0,0,1,3.367,5.856c.027.4.289.549.542.73a78.314,78.314,0,0,1,8.721,7.277,34.778,34.778,0,0,1,4.8,5.49,10.114,10.114,0,0,1,1.944,4.839A3.832,3.832,0,0,1,45.8,39.7a9.655,9.655,0,0,1-7.323-3.045,21.334,21.334,0,0,1-3.854-5.869,72.749,72.749,0,0,1-3.046-7.022c-.065-.171-.141-.338-.228-.543",
    transform: "translate(0 0)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M342.643,779.893a23.644,23.644,0,0,1-8.979-1.656.92.92,0,0,1-.656-.789,8.892,8.892,0,0,1,.188-4.165c.115-.368.225-.381.545-.228a21.254,21.254,0,0,0,16.094.86,10.158,10.158,0,0,0,2.033-.911c.2-.115.279-.1.351.125a8.59,8.59,0,0,1,.112,4.706c-.073.3-.308.331-.518.413a23.993,23.993,0,0,1-9.17,1.644",
    transform: "translate(-317.905 -738.227)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M388.807,624.8a17.727,17.727,0,0,1-6.89-1.364c-.391-.164-.509-.3-.25-.71a15.381,15.381,0,0,0,1.368-2.714c.148-.385.314-.369.636-.241a14.59,14.59,0,0,0,11.265-.057c.255-.1.349-.067.444.182a14.229,14.229,0,0,0,1.531,3.025c.247.36-.045.388-.244.475a18.95,18.95,0,0,1-7.859,1.4",
    transform: "translate(-364.398 -591.84)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M402.018,987.3a12.715,12.715,0,0,1-2.108,2.462,11.058,11.058,0,0,1-5.058,2.554,1.764,1.764,0,0,1-.8,0,10.948,10.948,0,0,1-6.987-4.836.531.531,0,0,1-.04-.138,21.618,21.618,0,0,0,14.993-.039",
    transform: "translate(-369.646 -942.966)",
    fill: "#ed3a72"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(1667.004 6203.84) rotate(-44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173-2",
    "data-name": "Group 173",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3936-2",
    "data-name": "Path 3936",
    d: "M31.348,23.223a8.523,8.523,0,0,1-6.537,2.84,8.333,8.333,0,0,1-6.471-2.792,2.646,2.646,0,0,0-.381.8,56.825,56.825,0,0,1-5.035,10.387,11.2,11.2,0,0,1-5.864,4.776,7.583,7.583,0,0,1-3.745.412A3.841,3.841,0,0,1,.033,35.211a10.88,10.88,0,0,1,2.245-5.1A52.055,52.055,0,0,1,11.7,20.647q1.859-1.535,3.836-2.918a1.076,1.076,0,0,0,.514-.857,7.61,7.61,0,0,1,3.311-5.632c.356-.255.427-.417.177-.821A4.045,4.045,0,0,1,20.8,4.547a.622.622,0,0,0,.308-.785A2.532,2.532,0,0,0,18.6,1.528a12.648,12.648,0,0,0-1.823-.1,1.022,1.022,0,0,1-.667-.2.621.621,0,0,1-.253-.671.69.69,0,0,1,.571-.514,3.136,3.136,0,0,1,1.407.089,13.806,13.806,0,0,1,2.99,1.1A1.823,1.823,0,0,1,21.81,2.4c.107.356.236.706.342,1.062.087.292.244.361.531.251A6.228,6.228,0,0,1,27.005,3.7c.3.1.454.041.492-.267A3.211,3.211,0,0,1,30.1.675,14.38,14.38,0,0,1,32.39.044,3.243,3.243,0,0,1,33.1.016c.412.035.722.22.719.688a.688.688,0,0,1-.7.719c-.572.052-1.149.052-1.722.084a4.767,4.767,0,0,0-.653.086,2.5,2.5,0,0,0-2.261,2.434.268.268,0,0,0,.115.3c.084.057.169.112.252.17a4.144,4.144,0,0,1,1.24,5.977c-.2.326-.2.472.122.7a7.5,7.5,0,0,1,3.367,5.856c.027.4.289.549.542.73a78.314,78.314,0,0,1,8.721,7.277,34.778,34.778,0,0,1,4.8,5.49,10.114,10.114,0,0,1,1.944,4.839A3.832,3.832,0,0,1,45.8,39.7a9.655,9.655,0,0,1-7.323-3.045,21.334,21.334,0,0,1-3.854-5.869,72.749,72.749,0,0,1-3.046-7.022c-.065-.171-.141-.338-.228-.543",
    transform: "translate(0 0)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937-2",
    "data-name": "Path 3937",
    d: "M342.643,779.893a23.644,23.644,0,0,1-8.979-1.656.92.92,0,0,1-.656-.789,8.892,8.892,0,0,1,.188-4.165c.115-.368.225-.381.545-.228a21.254,21.254,0,0,0,16.094.86,10.158,10.158,0,0,0,2.033-.911c.2-.115.279-.1.351.125a8.59,8.59,0,0,1,.112,4.706c-.073.3-.308.331-.518.413a23.993,23.993,0,0,1-9.17,1.644",
    transform: "translate(-317.905 -738.227)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938-2",
    "data-name": "Path 3938",
    d: "M388.807,624.8a17.727,17.727,0,0,1-6.89-1.364c-.391-.164-.509-.3-.25-.71a15.381,15.381,0,0,0,1.368-2.714c.148-.385.314-.369.636-.241a14.59,14.59,0,0,0,11.265-.057c.255-.1.349-.067.444.182a14.229,14.229,0,0,0,1.531,3.025c.247.36-.045.388-.244.475a18.95,18.95,0,0,1-7.859,1.4",
    transform: "translate(-364.398 -591.84)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939-2",
    "data-name": "Path 3939",
    d: "M402.018,987.3a12.715,12.715,0,0,1-2.108,2.462,11.058,11.058,0,0,1-5.058,2.554,1.764,1.764,0,0,1-.8,0,10.948,10.948,0,0,1-6.987-4.836.531.531,0,0,1-.04-.138,21.618,21.618,0,0,0,14.993-.039",
    transform: "translate(-369.646 -942.966)",
    fill: "#ed3a72"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBackground);
export default __webpack_public_path__ + "static/media/contact-background.23e19f1234d2a54e398d47cbb6a1695b.svg";
export { ForwardRef as ReactComponent };